module.exports = __webpack_public_path__ + "img/construction-waiting.fe54596a.jpg";